// Session tokens issued by the API (POST /v1/auth/*). Kept in localStorage so a refresh
// survives reloads, with an in-memory cache so the request interceptor stays synchronous.
// The frontend never talks to Supabase directly — refresh goes through the API.
const KEY = 'proref.auth';

export interface AuthTokens {
  access_token: string;
  refresh_token: string;
}

let cache: AuthTokens | null = read();

function read(): AuthTokens | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as AuthTokens) : null;
  } catch {
    return null;
  }
}

export function getTokens(): AuthTokens | null {
  return cache;
}

export function setTokens(tokens: AuthTokens): void {
  cache = tokens;
  try {
    localStorage.setItem(KEY, JSON.stringify(tokens));
  } catch {
    // Private-mode / disabled storage — the in-memory cache still carries the session.
  }
}

export function clearTokens(): void {
  cache = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
